import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import React from 'react';

import Icon from 'uikit/Icon';

import imageGoogleLogo from './images/google.png';
import imageMicrosoftLogo from './images/microsoft.png';
import styles from './Social.module.scss';

const cx = classNames.bind(styles);

const Social = ({ className, organization, t }) => (
  <div className={cx('container', className)}>
    <p className={cx('or')}>
      <span>{t('Auth/Shared/Social/or')}</span>
    </p>
    <div className={cx('buttons')}>
      {(!organization ||
        !organization.forceSSO ||
        (organization.forceSSO && organization.allowGoogleSSO)) && (
        <a
          className={cx('button', 'google')}
          href={`${process.env.REACT_APP_API_URL}/api/auth/google/login`}
        >
          <img
            alt=""
            aria-hidden="true"
            className={cx('logo')}
            src={imageGoogleLogo}
          />
        </a>
      )}
      {(!organization ||
        !organization.forceSSO ||
        (organization.forceSSO && organization.allowMicrosoftSSO)) && (
        <a
          className={cx('button', 'microsoft')}
          href={`${process.env.REACT_APP_API_URL}/api/auth/azure-ad/login`}
        >
          <img
            alt=""
            aria-hidden="true"
            className={cx('logo')}
            src={imageMicrosoftLogo}
          />
        </a>
      )}
      {(!organization || (organization && !organization.forceSSO)) && (
        <a
          className={cx('button', 'apple')}
          href={`${process.env.REACT_APP_API_URL}/api/auth/apple/login`}
        >
          <Icon className={cx('logo')} name="apple" variant="brand" />
        </a>
      )}
      {(!organization || (organization && !organization.forceSSO)) && (
        <a
          className={cx('button', 'facebook')}
          href={`${process.env.REACT_APP_API_URL}/api/auth/facebook/login`}
        >
          <Icon className={cx('logo')} name="facebook" variant="brand" />
        </a>
      )}
    </div>
  </div>
);

Social.propTypes = {
  className: PropTypes.string,
  organization: PropTypes.object,
  t: PropTypes.func.isRequired,
};

Social.defaultProps = {
  className: undefined,
  organization: undefined,
};

export default Social;
